import { Card, Select } from "antd";
import React, { useEffect, useState } from "react";
import { getNormalDashboardUsers } from "../apis/user";
import QuarterUsersGraph from "../components/common/QuarterUsersGraph";
import CustomLayout from "../components/layout/CustomLayout";
import { graphOptions } from "../utils/constant";
import WithAuthLayout from "../routeProtector/withAuth";
import { useSelector } from "react-redux";
import { useLoader } from "../components/common/Loader/LoaderProvider";
import useDocumentTitle from "../utils/useDocumentTitle";

const Dashboard = () => {
  const userObj = useSelector((state) => state?.userObj);
  console.log("userObj in dashboard", userObj);
  const [totalUserData, setTotalUserData] = useState(0); // Static data
  const [totalSearchData, setTotalSearchData] = useState(0); // Static data
  const [totalBetData, setTotalBetData] = useState(0); // Static data
  const loaderContext = useLoader();
  const { showLoader, hideLoader } = loaderContext;
  const [chartBarData, setChartBarData] = useState({
    data: { labels: [], datasets: [] },
    options: {},
  });
  const [months, setMonths] = useState(3);

  const handlePreviousMonths = (month) => {
    setMonths(month);
  };
  useDocumentTitle("Dashboard");

  useEffect(() => {
    // API call to fetch data
    getNormalDashboardUsers(months).then((res) => {
      showLoader();
      if (res.status) {
        setTotalBetData(res?.data?.data?.total_bets || 0);
        setTotalUserData(res?.data?.data?.total_users || 0);
        setTotalSearchData(res?.data?.data?.total_searches || 0);
        setChartBarData({
          data: {
            labels: res?.data?.data?.total_users_by_months?.monthYear || [],
            datasets: [
              {
                label: "Users Registered",
                maxBarThickness: 45,
                data: res?.data?.data?.total_users_by_months?.usersCount || [],
                backgroundColor: "rgba(54, 162, 235, 0.6)",
                borderColor: "rgba(54, 162, 235, 1)",
                borderWidth: 2,
                borderRadius: 8, // Rounded corners
              },
            ],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false,
                labels: {
                  color: "#ffffff", // White text for dark mode
                },
              },
              title: {
                display: true,
                text: "User Registration Statistics", // Chart Title
                color: "#ffffff",
                font: { size: 16 },
              },
            },
            // scales: {
            //   x: {
            //     grid: {
            //       display: true, // Show x-axis grid lines
            //       color: "rgba(255, 255, 255, 0.2)", // Light grid lines
            //     },
            //     ticks: {
            //       color: "#ffffff", // White text
            //     },
            //     title: {
            //       display: true,
            //       text: "Months", // X-axis label
            //       color: "#ffffff",
            //       font: { size: 14 },
            //     },
            //   },
            //   y: {
            //     grid: {
            //       display: true, // Show y-axis grid lines
            //       color: "rgba(255, 255, 255, 0.2)", // Light grid lines
            //     },
            //     ticks: {
            //       color: "#ffffff",
            //     },
            //     title: {
            //       display: true,
            //       text: "Number of Users", // Y-axis label
            //       color: "#ffffff",
            //       font: { size: 14 },
            //     },
            //   },
            // },
          },
        });
      }
      hideLoader();
    });
  }, [months]);

  return (
    <CustomLayout>
      <div className="flex flex-col gap-7">
        {/* Static Data */}
        <div className="flex flex-row gap-4">
          <Card bordered={false} className="border !w-full h-full p-10">
            <div className="font-bold flex flex-col items-center">
              <h2>Total Users</h2>
              <p className="text-xl text-blue-600">{totalUserData}</p>
            </div>
          </Card>
          <Card bordered={false} className="border !w-full h-full p-10">
            <div className="font-bold flex flex-col items-center">
              <h2>Total Bets</h2>
              <p className="text-xl text-blue-600">{totalBetData}</p>
            </div>
          </Card>
        </div>

        {/* Graph with Static Data */}
        <Card
          title={<div className="text-lg">User Statistics</div>}
          bordered={false}
          className="border w-full !h-fit"
        >
          <Select
            defaultValue={months}
            value={months}
            style={{ width: 150 }}
            onChange={handlePreviousMonths}
            options={graphOptions}
          />
          {chartBarData?.data?.datasets?.length > 0 &&
          chartBarData?.data?.labels?.length > 0 ? (
            <div className="!w-full h-[300px]">
              <QuarterUsersGraph
                graphType={"bar"}
                chartData={chartBarData?.data}
                options={chartBarData?.options}
                className="!h-full"
              />
            </div>
          ) : (
            <h1>No Data Found</h1>
          )}
        </Card>
      </div>
    </CustomLayout>
  );
};

export default WithAuthLayout(Dashboard);
